/* eslint-disable import/no-duplicates */
// eslint-disable-next-line import/no-duplicates
import Api from "../../lib/api";
import axios from "../../lib/api";
import { setMessage } from "../shared/notification/slice";

export const fetchTripCoordinates = async (tripId) => {
    try {
        const response = await Api.get(`trips/${tripId}/coordinates`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};

export const fetchTripSnapToRoadCoordinates = async (tripId) => {
    try {
        const response = await Api.get(`trips/${tripId}/snap_to_roads_coordinates`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};

export const fetchTripPoints = async (tripId) => {
    try {
        const response = await Api.get(
            `trip-logs?filter[tripId]=${tripId}&page[size]=100&sort=loggedAt&filter[logType]=trip_point,waiting_point,error`
        );
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};

export const getTripPrices = async (tripId) => {
    try {
        const response = await Api.get(`trips/${tripId}/trip-price`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};
export const updateTripPrices = async (tripId, body) => {
    try {
        const response = await axios.put(`trips/${tripId}/trip-price`, body);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};
export const fetchTripSummary = async (tripId) => {
    try {
        const response = await axios.get(`trips/${tripId}/summary`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};
export const uploadTripAttachments = async (tripId, attachments) => {
    try {
        const response = await Api.post(`attachments`, {
            data: {
                type: "attachments",
                attributes: {
                    attachedItemId: tripId,
                    attachedItemType: "Trip",
                    documentType: "trip",
                    document: attachments,
                },
            },
        });
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};
export const deleteTripAttachment = async (attachmentId) => {
    try {
        const response = await Api.delete(`attachments/${attachmentId}`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};
